import { getChromeRuntime } from '../chrome/wrappers';

export const isExtensionActive = () => getChromeRuntime().id !== undefined;
